"use client";

import React, { useEffect, useState } from "react";
import { Code, FileType, Palette, Layers, Server, PenTool, Cpu, Database, Globe, Smartphone, ShieldCheck, Zap } from "lucide-react";
import { HoverCard, HoverCardContent, HoverCardTrigger } from "@/components/ui/hover-card";
import { cn } from "@/lib/utils";
const expertiseItems = [{
  id: "01",
  title: "Uniek Design",
  subtitle: "Visuele Perfectie",
  description: "Wij creëren high-end ontwerpen die de identiteit van uw merk versterken. Geen templates, maar unieke digitale ervaringen met oog voor elk detail.",
  icon: Palette,
  details: ["Maatwerk UI", "Brand Identity", "Figma Design", "Motion Graphics"]
}, {
  id: "02",
  title: "Snelheid",
  subtitle: "Bliksemsnel",
  description: "Onze websites zijn geoptimaliseerd voor maximale prestaties. Snelle laadtijden zorgen voor een betere gebruikerservaring en hogere conversieratio's.",
  icon: Zap,
  details: ["Core Web Vitals", "Edge Caching", "Optimized Assets", "Lighthouse 100"]
}, {
  id: "03",
  title: "Vindbaarheid",
  subtitle: "SEO Kracht",
  description: "Wij bouwen websites met een solide SEO-fundament. Uw bedrijf wordt beter gevonden in Google door technische perfectie en slimme structuur.",
  icon: Globe,
  details: ["Sitemap XML", "Meta Data", "Semantic HTML", "Schema Markup"]
}, {
  id: "04",
  title: "Responsief",
  subtitle: "Overal Perfect",
  description: "Een naadloze ervaring op elk scherm. Van smartphone tot ultra-wide desktop, uw website ziet er overal professioneel en functioneel uit.",
  icon: Smartphone,
  details: ["Mobile First", "Fluid Layouts", "Touch Optimized", "Adaptive Media"]
}, {
  id: "05",
  title: "Veiligheid",
  subtitle: "Fort Knox Security",
  description: "Beveiliging staat bij ons voorop. Wij implementeren de nieuwste protocollen om uw data en die van uw klanten 24/7 te beschermen.",
  icon: ShieldCheck,
  details: ["SSL Certificaten", "DDoS Protection", "Secure Auth", "GDPR Ready"]
}, {
  id: "06",
  title: "Maatwerk Code",
  subtitle: "Unique Code",
  description: "Wij schrijven schone, efficiënte code die specifiek voor uw doelen is ontwikkeld. Dit zorgt voor stabiliteit en onbeperkte mogelijkheden.",
  icon: Code,
  details: ["Next.js & React", "TypeScript", "Clean Code", "Scalable Logic"]
}, {
  id: "07",
  title: "Gebruiksgemak",
  subtitle: "Intuïtieve UX",
  description: "Wij ontwerpen met de eindgebruiker in gedachten. Een logische navigatie en heldere interacties leiden uw bezoekers naar hun doel.",
  icon: Layers,
  details: ["User Journeys", "UX Research", "Accessibility", "A/B Testing"]
}, {
  id: "08",
  title: "Conversie",
  subtitle: "Resultaat Gericht",
  description: "Een website is een investering. Wij focussen op elementen die bezoekers aanzetten tot actie, van offerte-aanvragen tot directe verkopen.",
  icon: Cpu,
  details: ["CTA Optimization", "Analytics", "Funnel Design", "Lead Gen"]
}, {
  id: "09",
  title: "Beheerpaneel",
  subtitle: "Eenvoudig CMS",
  description: "U houdt de controle over uw eigen content. Wij integreren gebruiksvriendelijke systemen waarmee u eenvoudig teksten en beelden aanpast.",
  icon: FileType,
  details: ["Intuitive UI", "Media Library", "Role Access", "Training Inbegrepen"]
}, {
  id: "10",
  title: "Onderhoud",
  subtitle: "Zorgeloos Support",
  description: "Ook na de lancering staan we voor u klaar. Wij zorgen voor updates, back-ups en technische ondersteuning zodat u zich kunt focussen op uw business.",
  icon: Server,
  details: ["Daily Backups", "Core Updates", "Priority Support", "Hosting"]
}, {
  id: "11",
  title: "Schaalbaarheid",
  subtitle: "Klaar voor Groei",
  description: "Onze architectuur groeit met uw bedrijf mee. Of u nu 100 of 100.000 bezoekers per dag krijgt, uw systeem blijft stabiel presteren.",
  icon: Database,
  details: ["Cloud Native", "Elastic Load", "API First", "Database Opt."]
}, {
  id: "12",
  title: "Strategie",
  subtitle: "Digitale Strategie",
  description: "Wij denken mee over uw online groei. Van concept tot realisatie adviseren wij over de beste weg naar digitaal succes.",
  icon: PenTool,
  details: ["Market Analysis", "Growth Hacking", "Tech Roadmap", "ROI Focus"]
}];
export default function TechnologieenExpertise() {
  return <section data-section-id="61201" id="waarom-north-websites" className="dark bg-background text-foreground relative overflow-hidden py-24">
      {}
      <style dangerouslySetInnerHTML={{
      __html: `
        @keyframes scan-beam {
          0% { transform: translateX(-100%) skewX(-20deg); }
          100% { transform: translateX(200%) skewX(-20deg); }
        }
        .animate-scan {
          animation: scan-beam 10s linear infinite;
        }
      `
    }} />

      {}
      <div className="absolute inset-0 pointer-events-none">
        {}
        <div className="absolute inset-0 opacity-[0.03]" style={{
        backgroundImage: 'linear-gradient(to right, #ffffff 1px, transparent 1px), linear-gradient(to bottom, #ffffff 1px, transparent 1px)',
        backgroundSize: '40px 40px'
      }} />
        
        {}
        <div className="absolute inset-0 z-0 overflow-hidden">
          <div className="h-full w-1/3 bg-gradient-to-r from-transparent via-primary/10 to-transparent animate-scan blur-3xl" />
        </div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="mb-16 text-center max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-5xl font-bold tracking-widest mb-6 uppercase text-foreground">
            Waarom <span className="text-secondary">North Websites</span>?
          </h2>
          <p className="text-muted-foreground text-lg md:text-xl leading-relaxed font-sans">
            Wij combineren technische precisie met creatieve innovatie om uw bedrijf te voorzien van een superieur digitaal fundament dat klaar is voor de toekomst.
          </p>
        </div>

        {}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {expertiseItems.map((item, i) => <div key={item.id} data-index={i} className="group relative">
              <HoverCard openDelay={0} closeDelay={100}>
                <HoverCardTrigger asChild>
                  <div className={cn("relative h-full min-h-[180px] w-full cursor-pointer overflow-hidden rounded-lg border border-white/10 bg-card/20 p-6 backdrop-blur-sm transition-all duration-500", "hover:bg-card/40 hover:border-primary/50 hover:shadow-[0_0_40px_-15px_var(--color-primary)]", "flex flex-col justify-between items-start group-hover:-translate-y-2")}>
                    {}
                    <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-transparent to-secondary/5 opacity-0 group-hover:opacity-100 transition-opacity duration-700 pointer-events-none" />

                    {}
                    <span className="text-4xl font-bold text-transparent stroke-text opacity-10 group-hover:opacity-30 transition-opacity select-none tracking-tighter" style={{
                  WebkitTextStroke: '1px var(--color-muted-foreground)'
                }}>
                      {item.id}
                    </span>

                    {}
                    <div className="mt-auto space-y-3 relative z-10">
                      <div className="p-2 w-fit rounded-md bg-background/80 border border-white/5 text-primary group-hover:text-secondary group-hover:border-secondary/30 transition-all duration-300 group-hover:rotate-6">
                        <item.icon className="w-6 h-6" />
                      </div>
                      <div>
                        <h3 className="font-bold text-sm md:text-base tracking-wide text-foreground group-hover:text-primary transition-colors">
                          {item.title}
                        </h3>
                        <p className="text-[10px] uppercase tracking-widest text-muted-foreground mt-1 font-sans">
                          {item.subtitle}
                        </p>
                      </div>
                    </div>
                  </div>
                </HoverCardTrigger>
                
                <HoverCardContent side="top" align="center" className="w-80 border-primary/20 bg-background/95 backdrop-blur-2xl p-0 overflow-hidden shadow-2xl">
                  <div className="relative p-5">
                    {}
                    <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-primary via-secondary to-primary" />
                    
                    <div className="flex items-center gap-3 mb-3">
                      <div className="p-2 rounded bg-primary/10 text-primary">
                        <item.icon className="w-5 h-5" />
                      </div>
                      <h4 className="font-bold text-lg tracking-tight text-foreground">{item.title}</h4>
                    </div>
                    
                    <p className="text-sm text-muted-foreground leading-relaxed mb-4">
                      {item.description}
                    </p>

                    <div className="grid grid-cols-2 gap-2">
                      {item.details.map((detail, idx) => <div key={idx} className="flex items-center gap-2 text-xs text-foreground/90 bg-white/5 px-2 py-1.5 rounded border border-white/5">
                          <div className="w-1 h-1 rounded-full bg-secondary shadow-[0_0_5px_var(--color-secondary)]" />
                          {detail}
                        </div>)}
                    </div>
                  </div>
                </HoverCardContent>
              </HoverCard>
            </div>)}
        </div>
      </div>
    </section>;
}